import React from 'react';
import { useParams } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import servicesData from '../data/services.json';
import styles from '../styles/BusinessPotentialSection.module.css';

const BusinessPotentialSection = () => {
  const { serviceType } = useParams();
  const serviceContent = serviceType ? servicesData[serviceType as keyof typeof servicesData] : null;

  if (!serviceContent) return null;

  return (
    <section className={styles.businessPotentialSection}>
      <Container>
        <Row className="align-items-center">
          <Col lg={6}>
            <div className={styles.businessPotentialText}>
              <h2>{serviceContent.section_3.title}</h2> 
              <p className={styles.businessPotentialDescription}>
                {serviceContent.section_3.subtitle}
              </p>
            </div>
          </Col>
          <Col lg={6}>
            <Row className="g-3">
              {serviceContent.section_3.images?.map((image, index) => (
                <Col xs={6} key={index}>
                  <div className={styles.imageContainer}>
                    <img src={image} alt={`${serviceContent.section_3.title} Image ${index + 1}`} />
                  </div>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>

        <Row className="g-4 mt-4">
          {serviceContent.section_3.cards?.map((card, index) => (
            <Col key={index}>
              <div className={styles.businessPotentialCard}>
                <div className={styles.cardIcon}>
                  <img src={card.icon} alt={card.title} />
                </div>
                <h3>{card.title}</h3>
                <p>{card.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default BusinessPotentialSection; 